import TeslaFleetRedirect from './TeslaFleetRedirect'

export default function TeslaFleetAuthenticationPage() {
  return <TeslaFleetRedirect />
}
